// extracted by mini-css-extract-plugin
export default {"header":"style_header__hc7Ma","title":"style_title__hmdlJ"};